import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Collapse, List, ListItem } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BadgeIcon from '@mui/icons-material/Badge';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useState } from 'react';
import { Link } from 'react-router-dom'

const MainListItems = () => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    return (
        <React.Fragment>
            <ListItemButton component={Link} to="/inicio">
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Tablero" />
            </ListItemButton>
            <ListItemButton component={Link} to="/perfil">
                <ListItemIcon>
                    <BadgeIcon />
                </ListItemIcon>
                <ListItemText primary="Mi perfil" />
            </ListItemButton>
            <ListItemButton component={Link} to="/mi-red">
                <ListItemIcon>
                    <AccountTreeIcon />
                </ListItemIcon>
                <ListItemText primary="Mi Red" />
            </ListItemButton>
            <ListItemButton component={Link} to="/mi-red-mapa">
                <ListItemIcon>
                    <EditLocationIcon />
                </ListItemIcon>
                <ListItemText primary="Ubicacion mi red" />
            </ListItemButton>
            <ListItemButton component={Link} to="/comision-mensual">
                <ListItemIcon>
                    <PictureAsPdfIcon />
                </ListItemIcon>
                <ListItemText primary="Comision Mensual" />
            </ListItemButton>
            {/* <ListItemButton onClick={handleClick} >
                <ListItemIcon>
                    <BarChartIcon />
                </ListItemIcon>
                <ListItemText primary="Reportes" />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemButton> */}
            {/*   <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton component={Link} to="/vendedores">
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText disableTypography primary="Top 10 vendedores" style={{ fontSize: '14px' }} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/venta-residuales">
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText disableTypography primary="Red ventas y residual" style={{ fontSize: '14px' }} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/vendedores-mes">
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText disableTypography primary="Mejores vendedores" style={{ fontSize: '14px' }} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/ascensos">
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText disableTypography primary="Ascenso de rangos" style={{ fontSize: '14px' }} />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/ubicacion-red">
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText disableTypography primary="Ubicacion de mi red" style={{ fontSize: '14px' }} />
                    </ListItemButton>
                </List>
            </Collapse> */}
        </React.Fragment>
    )
};

const SecondaryListItems = () => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    return (
        <>
            <ListSubheader component="div" inset>
                Submenu
            </ListSubheader>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                    <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Otros" />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem >
                        <ListItemIcon>

                        </ListItemIcon>
                        <ListItemText primary='Otros' />
                    </ListItem>
                </List>
            </Collapse>
        </>
    );
}
export default { SecondaryListItems, MainListItems };
